<script>

  /**
   * Library Imports
   */
  import { onMount, onDestroy } from 'svelte';
  import scrollama from 'scrollama';

  /**
   * Component Imports
   */
  import Pattern from './assets/Pattern.svelte';
  import Arrow from './assets/Arrow.svelte';
  import Logo from './assets/Logo.svelte';
  import CircleArrow from './assets/CircleArrow.svelte';
  import CircleQuestion from './assets/CircleQuestion.svelte';
  import Mouse from './assets/Mouse.svelte';

  /**
   * Prop imports
   */
  export let data;
  export let linkToArticles;

  const arrowPadding = 30;
  const breakpoint = 768;

  let height = window.innerHeight;
  let width = window.innerWidth;
  let arrowProgress = 0;
  let bgColor = 'black';
  let explore = 'menu';

  $: patternHeight = Math.floor(height / 6);
  $: arrowHeight = Math.floor(height - (2 * patternHeight) - (2 * arrowPadding));

  // Look for resize event
  window.addEventListener('resize', () => {
    height = window.innerHeight;
    width = window.innerWidth;
  });

  /////////////////////////////////////////////////////////

  // initialize the scrollama
  const scroller = scrollama();

  // generic window resize listener event
  function handleResize() {
    // tell scrollama to update new element dimensions
    scroller.resize();
  }

  // scrollama event handlers
  function handleStepProgress(response) {
    const { element, progress, index} = response;

    if(index === 0) {
      document.getElementById('mouse').classList.remove('hidden');
    } else {
      document.getElementById('mouse').classList.add('hidden');
    }

    if (index === 0) {
      element.style.opacity = 1;
      document.querySelector('.step-wrap:nth-of-type(2)').style.opacity = 0;
    } else if (index === 1) {
      element.style.opacity = 1;
      document.querySelector('.step-wrap:nth-of-type(1)').style.opacity = 0;
    }

    if (width > breakpoint) {
      if (index === 0) {
        arrowProgress = progress - 0.5;
      } else if (index === 1) {
        arrowProgress = progress + 0.5;
      }
      if (arrowProgress < 0) arrowProgress = 0;
      if (arrowProgress > 1) arrowProgress = 1;
    } else {
      arrowProgress = 0;
    }

    bgColor = "black";
  }

  function init() {
    // 1. force a resize on load to ensure proper dimensions are sent to scrollama
    handleResize();

    // 2. setup the scroller passing options
    // 		this will also initialize trigger observations
    // 3. bind scrollama event handlers (this can be chained like below)
    scroller.setup({
      step: '.inner-content .step-wrap',
      offset: 0.5,
      progress: true,
      // debug: true,
    }).onStepProgress(handleStepProgress);

    // setup resize event
    window.addEventListener('resize', handleResize);
  }

  const initScrollChoose = scrollTo => {
    window.scrollTo({ top: scrollTo });

    setTimeout(() => {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (Math.abs(scrollTo - currentScroll) > 50) {
        initScrollChoose(scrollTo);
      }
    }, 500);
  };

  onMount(() => {
    // kick things off
    init();

    const scrollTo = height - 2 * patternHeight;

    // Jump straight to selector
    if (window.location.hash === '#category') {
      initScrollChoose(scrollTo);
    }
  });

  onDestroy(() => {
    scroller.destroy();
  });

  /////////////////////////////////////////////////////////

  function noScroll() {
    document.querySelector(`#choose`).scrollIntoView();
  }

  const exploreType = type => e => {
    switch (type) {
      case 'global':
        bgColor = '#8EC089';
        explore = 'global';
        noScroll();
        window.addEventListener('scroll', noScroll);
        break;
      case 'local':
        bgColor = '#2F4666';
        explore = 'local';
        noScroll();
        window.addEventListener('scroll', noScroll);
        break;
      case 'digital':
        bgColor = '#DC8014';
        explore = 'digital';
        noScroll();
        window.addEventListener('scroll', noScroll);
        break;
      default:
        bgColor = 'black';
        explore = 'menu';
        window.removeEventListener('scroll', noScroll);
    }
  };

  const redirect = type => () => {
    window.removeEventListener('scroll', noScroll);
    linkToArticles(type);
  };
</script>

<style>
  h1 {
    font-size: 48px;
    margin-bottom: 12px;
    line-height: 1.4em;
    display: inline-block;
    white-space: pre-wrap;
  }

  h2 {
    font-size: 32px;
    line-height: 1.3em;
    display: inline-block;
    margin-bottom: 10px;
    white-space: pre-wrap;
  }

  p {
    margin-bottom: 20px;
    white-space: pre-wrap;
  }

  .logo {
    margin-right: 25px;
  }

  .headline {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    width: 100%;
  }

  .intro-box {
    position: fixed;
    background-color: black;
    overflow: hidden;
    top: 0;
    width: 100%;
    transition: background-color 0.5s;
  }

  @media screen and (max-width: 768px) {
    h1 {
      font-size: 38px;
    }

    h2 {
      font-size: 28px;
    }
  }

  /* ******************************************************
   * PATTERN CLASSES
   */
  .pattern {
    position: absolute;
  }

  .tl { top: 0; right: calc(50% + 100px); }
  .tl.small { right: calc(50% + 50px); }

  .tr { top: 0; left: calc(50% + 100px); }
  .tr.small { left: calc(50% + 50px); }

  .bl { bottom: 0; right: calc(50% + 100px); }
  .bl.small { right: calc(50% + 50px); }

  .br { bottom: 0; left: calc(50% + 100px); }
  .br.small { left: calc(50% + 50px); }

  .arrowPattern {
    position: absolute;
    top: 170px;
    bottom: 170px;
    z-index: 200;
  }

  .left { left: calc(-150px + 5%); }
  .left.small { left: calc(-350px + 10%); }

  .right { right: calc(-150px + 5%); }
  .right.small { right: calc(-350px + 10%); }

  .mouse {
    position: fixed;
    bottom: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100vw;
    padding: 30px;
    opacity: 1;
    transition: opacity 0.5s;
  }

  .mouse.hidden {
    opacity: 0;
  }

  /* ******************************************************
   * CONTENT CLASSES
   */
  .content {
    background-color: white;
    position: absolute;
    top: 150px;
    bottom: 150px;
    left: 0;
    right: 0;
    padding: 0 30px;
  }

  .inner-content {
    position: relative;
    width: 100%;
    max-width: 480px;
    font-size: 16px;
    line-height: 1.6em;
    margin: auto;
    color: black;
  }

  .step-wrap {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.1s;
  }

  .step-wrap.end {
    height: 1px;
  }

  .step {
    padding: 0 30px;
    width: 100%;
    text-align: center;
  }

  /* ******************************************************
   * EXPLORE CLASSES
   */
  .choose-menu {
    display: none;
  }
  .choose-menu.active {
    display: block;
  }

  .choose-buttons {
    margin-bottom: 30px;
  }

  .choose-buttons h3 {
    color: #888;
    margin-top: -10px;
  }

  .explore-global, .explore-local, .explore-digital {
    display: none;
  }
  .explore-global.active, .explore-local.active, .explore-digital.active {
    display: block;
  }

  .explore-button {
    border: none;
    background: none;
    padding: 0;
  }

  .explore-button-nav {
    background-color: white;
    border: none;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    padding: 15px 15px 10px;
    border-radius: 0;
    margin: 0 15px;
    border-bottom: 6px solid white;
  }

  @media screen and (max-width: 768px) {
    .choose-buttons {
      margin-bottom: 20px;
    }
  }
</style>

<div class="intro-box" style="height: {height}px; background-color: {bgColor};">
  <div class="pattern tl {(width > breakpoint) ? '' : 'small'}"><Pattern height={patternHeight} flipX /></div>
  <div class="pattern tr {(width > breakpoint) ? '' : 'small'}"><Pattern height={patternHeight} /></div>
  <div class="pattern bl {(width > breakpoint) ? '' : 'small'}"><Pattern height={patternHeight} flipX flipY /></div>
  <div class="pattern br {(width > breakpoint) ? '' : 'small'}"><Pattern height={patternHeight} flipY /></div>
  <div class="content" style="top: {patternHeight}px; bottom: {patternHeight}px;"></div>
  <div
    class="arrowPattern left {(width > breakpoint) ? '' : 'small'}"
    style="top: {patternHeight + arrowPadding}px; bottom: {patternHeight + arrowPadding}px;"
  >
    <Arrow color={bgColor} height={arrowHeight} flip={arrowProgress} reverse />
  </div>
  <div
    class="arrowPattern right {(width > breakpoint) ? '' : 'small'}"
    style="top: {patternHeight + arrowPadding}px; bottom: {patternHeight + arrowPadding}px;"
  >
    <Arrow color={bgColor} height={arrowHeight} flip={arrowProgress} />
  </div>
  <div class="mouse" id="mouse" style="height: {patternHeight}px;"><Mouse /></div>
</div>

<div class="inner-content" style="height: {height - 2 * patternHeight}px;">
  <div class="step-wrap" style="margin-top: {patternHeight}px;">
    <div class="step">
      <div class="headline"><span class="logo"><Logo height="48" /></span><h1>{data.main_title}</h1></div>
      <p>{data.main_description}</p>
    </div>
  </div>
  <div class="step-wrap" style="margin-bottom: {patternHeight}px;">
    <div class="step" id="choose">

      <div class="choose-menu {explore === 'menu' && 'active'}">
        <div class="headline"><h2>{data.choose}</h2></div>
        <div class="choose-buttons">
          <button class="explore-button" on:click={exploreType('global')}>
            <CircleArrow color="#BEDDBB" /><h3>{data.categories.global.title}</h3>
          </button>
          <button class="explore-button" on:click={exploreType('local')}>
            <CircleQuestion /><h3>{data.categories.local.title}</h3>
          </button>
          <button class="explore-button" on:click={exploreType('digital')}>
            <CircleArrow color="#EDB548" reverse /><h3>{data.categories.digital.title}</h3>
          </button>
        </div>
        <p>{data.choose_description}</p>
      </div>

      <div class="explore-global {explore === 'global' && 'active'}">
        <h2>{data.categories.global.title}</h2>
        <p>{data.categories.global.description}</p>
        <button class="explore-button-nav" on:click={exploreType()}>回上一頁</button>
        <button class="explore-button-nav" style="border-bottom: 6px solid {bgColor};" on:click={redirect('global')}>出發吧！</button>
      </div>

      <div class="explore-local {explore === 'local' && 'active'}">
        <h2>{data.categories.local.title}</h2>
        <p>{data.categories.local.description}</p>
        <button class="explore-button-nav" on:click={exploreType()}>回上一頁</button>
        <button class="explore-button-nav" style="border-bottom: 6px solid {bgColor};" on:click={redirect('local')}>出發吧！</button>
      </div>

      <div class="explore-digital {explore === 'digital' && 'active'}">
        <h2>{data.categories.digital.title}</h2>
        <p>{data.categories.digital.description}</p>
        <button class="explore-button-nav" on:click={exploreType()}>回上一頁</button>
        <button class="explore-button-nav" style="border-bottom: 6px solid {bgColor};" on:click={redirect('digital')}>出發吧！</button>
      </div>

    </div>
  </div>
  <div class="step-wrap end"></div>
</div>
